// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Keyboard } from 'swiper/modules';

// location swipers
const locationSwipers = document.querySelectorAll('.swiper-locations');
for( let i = 0; i< locationSwipers.length; i++ ) {

    let swiperNumber= i + 1;

    locationSwipers[i].classList.add('swiper-container-' + swiperNumber);
    let swiperClass = '.swiper-container-' + swiperNumber;
    
    // find element with swiperClass 
    let swiperClassEl = document.querySelector(swiperClass);
    let nextEl = swiperClassEl.querySelector('.swiper-button-next');
    let prevEl = swiperClassEl.querySelector('.swiper-button-prev');

    nextEl.classList.add('swiper-button-next-' + swiperNumber);
    prevEl.classList.add('swiper-button-prev-' + swiperNumber);

    // create swiper
    let swiper = new Swiper(swiperClass, {
        modules: [Pagination, Navigation, Keyboard],
        direction: 'horizontal',
        spaceBetween: 0,
        slidesPerView: 'auto',    
        spaceBetween: 24,     
        keyboard: {
            enabled: true,
        },  
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
        navigation: {
            nextEl: '.swiper-button-next-' + swiperNumber,
            prevEl: '.swiper-button-prev-' + swiperNumber,
        }
    });

}

// event swipers
const eventSwipers = document.querySelectorAll('.swiper-events');
for( let i = 0; i< eventSwipers.length; i++ ) {

    let swiperNumber= i + 1;

    eventSwipers[i].classList.add('swiper-events-container-' + swiperNumber);
    let swiperClass = '.swiper-events-container-' + swiperNumber;
    
    // find element with swiperClass 
    let swiperClassEl = document.querySelector(swiperClass);
    let nextEl = swiperClassEl.querySelector('.swiper-button-next');
    let prevEl = swiperClassEl.querySelector('.swiper-button-prev');

    nextEl.classList.add('swiper-button-next-' + swiperNumber);
    prevEl.classList.add('swiper-button-prev-' + swiperNumber);

    // create swiper
    let swiper = new Swiper(swiperClass, {
        modules: [Pagination, Navigation],
        direction: 'horizontal',
        spaceBetween: 0,
        slidesPerView: 'auto',    
        spaceBetween: 24,   
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
        navigation: {
            nextEl: '.swiper-button-next-' + swiperNumber,
            prevEl: '.swiper-button-prev-' + swiperNumber,
        }
    });

}

// posts swipers
const postsSwipers = document.querySelectorAll('.swiper-posts');
for( let i = 0; i< postsSwipers.length; i++ ) {

    let swiperNumber= i + 1;

    postsSwipers[i].classList.add('swiper-posts-container-' + swiperNumber);
    let swiperClass = '.swiper-posts-container-' + swiperNumber;
    
    // find element with swiperClass 
    let swiperClassEl = document.querySelector(swiperClass);
    let nextEl = swiperClassEl.querySelector('.swiper-button-next');
    let prevEl = swiperClassEl.querySelector('.swiper-button-prev');

    nextEl.classList.add('swiper-button-next-' + swiperNumber);
    prevEl.classList.add('swiper-button-prev-' + swiperNumber);

    // create swiper
    let swiper = new Swiper(swiperClass, {
        modules: [Pagination, Navigation],
        direction: 'horizontal',
        spaceBetween: 0,
        slidesPerView: 'auto',    
        spaceBetween: 24,   
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
        navigation: {
            nextEl: '.swiper-button-next-' + swiperNumber,
            prevEl: '.swiper-button-prev-' + swiperNumber,
        }
    });

}